<proffeo-ui-dialog [title]="'change-your-password' | translate">
  <form
    [formRoot]="form"
    class="flex flex-col gap-2 w-full"
  >
    <proffeo-ui-input
      [formField]="form.oldPassword"
      label="current-password"
      type="password"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.newPassword"
      label="reset-password-new-password"
      type="password"
      class="w-full"
    />

    <proffeo-ui-input
      [formField]="form.confirmPassword"
      label="reset-password-new-password-confirm"
      type="password"
      class="w-full"
    />
  </form>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <div class="flex w-full items-center justify-end gap-2">
      <proffeo-ui-button
        text="close"
        matDialogClose
      ></proffeo-ui-button>
      <proffeo-ui-button
        (clicked)="changePassword()"
        [disabled]="form().invalid() || form().submitting()"
        variant="accent"
        text="change-password"
      ></proffeo-ui-button>
    </div>
  </div>
</proffeo-ui-dialog>
